import { User } from './user';
import { UserPreferenceHeader } from './userPreferenceHeader';
//import { UserOffice } from './userOffice';

// FYI: Property names in .net and angular must be the same
export class UserDto {
  user!: User[];
  userPreference!: UserPreferenceHeader[];
}
